import { VuexClassModuleFactory } from "./module-factory";
export function Module(arg) {
    if (typeof arg === "function") {
        return moduleDecoratorFactory()(arg);
    }
    else {
        return moduleDecoratorFactory(arg);
    }
}
function moduleDecoratorFactory(moduleOptions) {
    return function (constructor) {
        var accessor = function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var instance = new ((_a = constructor.prototype.constructor).bind.apply(_a, [void 0].concat(args)))();
            Object.setPrototypeOf(instance, accessor.prototype);
            var factory = new VuexClassModuleFactory(constructor, instance, moduleOptions || {});
            factory.registerVuexModule();
            return factory.buildAccessor();
        };
        accessor.prototype = Object.create(constructor.prototype);
        accessor.prototype.constructor = accessor;
        return accessor;
    };
}
